import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// Configurations
import Config from '@/config'

// Types
import type { UserStore } from '@/types/helpers/store/user'
import type { APIUserGroupItem } from '@/types/api/items/user/user-group'

export const useUserStore = create<UserStore>()(
	persist(
		set => ({
			isLogin: false,
			lastCheckLoginDate: null,
			uuid: '',
			user_name: '',
			username: '',
			email: '',
			picture: '',
			group: null,
			setIsLogin: (isLogin: boolean) => set({ isLogin }),
			setLastCheckLoginDate: (lastCheckLoginDate: string | null) => set({ lastCheckLoginDate }),
			setUUID: (uuid: string) => set({ uuid }),
			setUser_Name: (user_name: string) => set({ user_name }),
			setUsername: (username: string) => set({ username }),
			setEmail: (email: string) => set({ email }),
			setPicture: (picture: string) => set({ picture }),
			setGroup: (group: APIUserGroupItem | null) => set({ group }),
			reset: () => set({ isLogin: false, lastCheckLoginDate: null, uuid: '', user_name: '', username: '', email: '', picture: '', group: null })
		}),
		{
			name: `${Config.shortName}-user`,
			storage: createJSONStorage(() => localStorage),
			...(typeof window !== 'undefined' && { storage: createJSONStorage(() => localStorage) })
		}
	)
)
